import { shadeColor } from 'utils';
import { BASE_COLORS } from '../constants';
import { ITheme } from '../types';

export const darkColorsTheme: ITheme = {
  semantic: {
    brandPrimary: '#A397FF',
    brandPrimaryHover: '#B7AEFF',
    brandAccent: '#65E884',
    navigationSurface: '#121430',
    navigationText: '#FFFFFF',
    surfacePage: '#1E2142',
    surfaceContainer: '#25284B',
    surfaceElevated: '#2D3158',
    surfaceMuted: '#222d59',
    surfaceHover: '#33375E',
    surfaceSelected: '#393D68',
    surfaceDisabled: '#30334F',
    textPrimary: '#F7F7FB',
    textSecondary: '#D3D5E3',
    textMuted: '#ADB1C6',
    textDisabled: '#7F849D',
    textOnBrand: '#121430',
    textOnLight: '#252461',
    borderSubtle: '#454A6F',
    borderStrong: '#686D91',
    focusRing: '#A397FF',
    overlayScrim: 'rgba(4, 5, 14, 0.68)',
    shadowElevated: '0 6px 20px rgba(4, 5, 14, 0.38)',
    shadowOverlay: '0 16px 44px rgba(4, 5, 14, 0.56)',
    statusSuccessText: '#8BE0A5',
    statusSuccessSurface: '#173B2A',
    statusSuccessBorder: '#4B9D68',
    statusWarningText: '#FFD28A',
    statusWarningSurface: '#49351C',
    statusWarningBorder: '#B88432',
    statusErrorText: '#FFADB5',
    statusErrorSurface: '#47252B',
    statusErrorBorder: '#B85E68',
    statusInfoText: '#A9D2FF',
    statusInfoSurface: '#1D3652',
    statusInfoBorder: '#4E83B8',
    highlightSurface: '#5A4316',
    highlightText: '#FFE9AD',
    authPanelBackground: 'rgba(18, 20, 48, 0.92)',
    scheduleTagBackground: '#E3F2FD',
    exportAction: '#7DDE92',
  },
  primary: '#339CFD',
  primary1: '#393D68',
  primaryGradient: 'linear-gradient(211.49deg, #dc88f5 15.89%, #339CFD 48.97%)',
  light: '#696969',
  secondary: '#0072DD',
  error: '#FFADB5',
  mediumErrorColor: '#47252B',
  darkError: '#FFADB5',
  warning: '#FFB765',
  success: '#57D682',
  background: '#1E2142',
  secondaryBackground: '#1c2137',
  secondaryBackgroundSelected: shadeColor('#1c2137', -5),
  additionalBackground: '#1D203E',
  collapseBackground: '#1D203E',
  timelineBackground: '#25284B',
  siderBackground: '#121430',
  spinnerBase: '#339CFD',
  scroll: '#797C9A',
  border: '#454A6F',
  borderNft: '#797C9A',
  textMain: '#F7F7FB',
  textLight: '#ADB1C6',
  textSuperLight: '#9296AE',
  textSecondary: '#ffffff',
  textDark: '#F7F7FB',
  textNftLight: '#797C9A',
  textSiderPrimary: '#339CFD',
  textSiderSecondary: '#797C9A',
  subText: '#ADB1C6',
  shadow: 'rgba(0, 0, 0, 0.07)',
  boxShadow: 'none',
  boxShadowHover: 'none',
  boxShadowNft:
    '0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
  boxShadowNftSecondary:
    '0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
  dashboardMapBackground: '#25284b',
  dashboardMapCircleColor: '#ACAEC1',
  dashboardMapControlDisabledBackground: '#7e7e7e',
  notificationSuccess: '#173B2A',
  notificationPrimary: '#1D3652',
  notificationWarning: '#49351C',
  notificationError: '#47252B',
  heading: BASE_COLORS.white,
  borderBase: '#686D91',
  disable: '#7F849D',
  disabledBg: '#30334F',
  layoutBodyBg: '#1e2142',
  layoutHeaderBg: '#1e2142',
  layoutSiderBg: '#121430',
  inputPlaceholder: '#ADB1C6',
  itemHoverBg: '#33375E',
  backgroundColorBase: '#1C2137',
  avatarBg: '#30334F',
  alertTextColor: '#F7F7FB',
  breadcrumb: '#ADB1C6',
  icon: '#ADB1C6',
  iconHover: '#ffffff',
};

export const antDarkColorsTheme = {
  successBg: '#173B2A',
  successBorder: '#4B9D68',
};
